/** ISO 3166-1 alpha-2 codes for African countries. Many do not use postal codes. */
const AFRICAN_COUNTRY_CODES = new Set([
  'DZ', 'AO', 'BJ', 'BW', 'BF', 'BI', 'CV', 'CM', 'CF', 'TD', 'KM', 'CG', 'CD', 'CI', 'DJ',
  'EG', 'GQ', 'ER', 'SZ', 'ET', 'GA', 'GM', 'GH', 'GN', 'GW', 'KE', 'LS', 'LR', 'LY', 'MG',
  'MW', 'ML', 'MR', 'MU', 'MA', 'MZ', 'NA', 'NE', 'NG', 'RW', 'ST', 'SN', 'SC', 'SL', 'SO',
  'ZA', 'SS', 'SD', 'TZ', 'TG', 'TN', 'UG', 'ZM', 'ZW', 'EH',
]);

export const isAfricanCountry = (code) =>
  AFRICAN_COUNTRY_CODES.has(String(code || '').trim().toUpperCase());

/** Postal/ZIP is optional for African countries. */
export const countryRequiresPostalCode = (code) => !isAfricanCountry(code);
